interface MarkProps {
  className?: string;
}

/** Filled check used in plan lists, trust rows and the comparison table. */
export function CheckMark({ className = "" }: MarkProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      className={`h-5 w-5 shrink-0 ${className}`}
    >
      <circle cx="10" cy="10" r="10" className="fill-current opacity-15" />
      <path
        d="M6 10.4l2.6 2.6L14 7.6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Muted cross for the "traditional way" column. */
export function CrossMark({ className = "" }: MarkProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      className={`h-5 w-5 shrink-0 ${className}`}
    >
      <circle cx="10" cy="10" r="10" className="fill-current opacity-10" />
      <path
        d="M7.2 7.2l5.6 5.6M12.8 7.2l-5.6 5.6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}
